import { isCanUseCallSettings } from 'util/getCallType';
import { isAccessRequestFeatureOn } from 'useCase/featureFlags/featureFlagsApi';
import { VCS_JOIN_POLICY } from 'consts';
import { isCallInitiator } from 'features/AccessRequests/utils/canBypassWaitingRoom';
import {
    resolveEffectiveJoinPolicy,
    resolveEffectiveModeratorsApprovalOnly,
} from 'features/PreJoin/utils/policy/admission';
import { isLocalUserModerator, isLocalUserModeratorByUserId } from 'useCase/moderation/status/moderators';
import { selectCallConfig, selectIsAuthorized, selectLocalParticipant } from 'state/selectors';

/** Авторизованный участник: только звук/уведомления, если вход с апрувом и не «только модераторы». */
export const canAuthorizedUserConfigureAccessRequestAlerts = (): boolean => {
    if (!selectIsAuthorized()) {
        return false;
    }
    if (resolveEffectiveJoinPolicy() === VCS_JOIN_POLICY.ALL) {
        return false;
    }
    return !resolveEffectiveModeratorsApprovalOnly();
};

/**
 * Видимость пункта «Управление звонком» / {@link CallSettingsModal}.
 * Инициатор/модератор — полные настройки. Авторизованный участник — только звук/уведомления при approval-политике.
 * Вызывать только из observer-компонента (читает mobx store).
 */
export const useCanSeeCallSettings = (): boolean => {
    if (!isCanUseCallSettings()) {
        return false;
    }

    if (!isAccessRequestFeatureOn()) {
        return false;
    }

    const isOnPrejoin = !selectLocalParticipant();
    if (isOnPrejoin) {
        if (isLocalUserModeratorByUserId()) {
            return true;
        }
        if (isCallInitiator(selectCallConfig()?.roomName)) {
            return true;
        }
    } else if (isLocalUserModerator() || isCallInitiator()) {
        return true;
    }

    return canAuthorizedUserConfigureAccessRequestAlerts();
};
